module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-96.c309eac4.svg";